/**
 * AcctRedirects — anciennes URL de la comptabilité du cabinet → tuiles unifiées (Batch #14.274).
 *   /admin/comptabilite?tab=…                       → /admin/comptabilite/<tuile>
 *   /admin/comptabilite/transactions-(clients|fournisseurs)/:sub → onglet correspondant
 *   /admin/invoices · /admin/expenses · /admin/products (anciens modules, supprimés)
 */
import { Navigate, useParams, useSearchParams } from "react-router-dom";

const TAB_TO_TILE = {
  ecritures: "grand-livre", "grand-livre": "grand-livre?tab=grand-livre", rapports: "rapports", plan: "plan", fournisseurs: "fournisseurs", clients: "clients",
};
const SUB_TO_TAB = {
  clients: { factures: "ventes", clients: "/admin/comptabilite/clients", rapports: "/admin/comptabilite/rapports?report=customer-journal", "report-gl": "/admin/comptabilite/grand-livre" },
  fournisseurs: { depenses: "achats", fiches: "/admin/comptabilite/fournisseurs", rapports: "/admin/comptabilite/rapports?report=supplier-journal", "report-gl": "/admin/comptabilite/grand-livre" },
};

export function ComptabiliteRedirect() {
  const [sp] = useSearchParams();
  const tab = sp.get("tab");
  if (!tab) return <Navigate to="/admin/cabinet" replace />;
  const target = TAB_TO_TILE[tab] || "grand-livre";
  const extra = ["report", "party"].filter((k) => sp.get(k)).map((k) => `${k}=${encodeURIComponent(sp.get(k))}`).join("&");
  return <Navigate to={`/admin/comptabilite/${target}${extra ? `${target.includes("?") ? "&" : "?"}${extra}` : ""}`} replace />;
}

export function TransactionsRedirect({ kind }) {
  const { sub } = useParams();
  const map = SUB_TO_TAB[kind];
  const t = map[sub];
  if (t && t.startsWith("/")) return <Navigate to={t} replace />;
  return <Navigate to={`/admin/comptabilite/transactions-${kind}${t ? `?tab=${t}` : ""}`} replace />;
}
